export default function editHousingCorporationReadyState(
  {patch}: any,
  {cid, ready}: {cid: number; ready: boolean},
): Promise<{}> {
  return patch(`/housing-corporations/ready`, {ready, cid}, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/housingCorporations/editHousingCorporationReadyState.tsx